import { render, staticRenderFns } from "./TournamentStandings.vue?vue&type=template&id=2c9c59f4&"
import script from "./TournamentStandings.vue?vue&type=script&lang=js&"
export * from "./TournamentStandings.vue?vue&type=script&lang=js&"
import style0 from "./TournamentStandings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports